import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Stack,
  Radio,
  DialogActions,
  Slide,
  Button,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";

const blue = {
  100: "#DAECFF",
  200: "#b6daff",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E5",
  900: "#003A75",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const WhatsAppInitDialogBox = ({
  whatsappOpenDialog,
  whatsappDialogClose,
  selectedUser,
}) => {
  const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
  const [serviceType, setserviceType] = useState("");
  const [serviceTypeValidation, setserviceTypeValidation] = useState(true);
  const [serviceMessage, setserviceMessage] = useState("");
  const [url, seturl] = useState("https://");
  const [Branch, setBranch] = useState();

  const serviceText = `Dear ${selectedUser.username}, 
We’ve completed a health check for your ${Branch}.
Find your detailed report and a quick video overview here:${url} 
This is an automated message. Please do not reply to this message.
For any queries and more details, please contact your Service Advisor.
    
Best regards, 
${Branch} Service`;

  const salesText = `Dear ${selectedUser.username}, 
I am ${loggedInAgent.username} from ${Branch} Group. Type "Hi" to continue the conversation Thank you.`;

  const partText = `Dear ${selectedUser.username}, 
I am ${loggedInAgent.username} from ${Branch} Group. Type "Hi" to continue the conversation for parts.
Thank you
`;

  useEffect(() => {
    if (serviceMessage) {
      if (serviceType == "Service") {
        setserviceMessage(serviceText);
      } else {
        setserviceMessage(salesText);
      }
      if (url.length > 8) {
        setserviceTypeValidation(false);
      } else {
        setserviceTypeValidation(true);
      }
    }
  }, [url, Branch]);

  const ClickToWhatsapp = () => {
    if (!serviceType) return;
    axios
      .post(
        BaseUrl + "/users/initatewhatsapp",
        {
          phonenumber: selectedUser.phonenumber,
          customername: selectedUser.username,
          agent_email: loggedInAgent.email,
          type: "whatsapp",
          agent_Type: serviceType,
          url: serviceType == "Service" ? url : "",
          branch: Branch,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          whatsappDialogClose();
          toast.success(res.data.message, {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
        } else {
          whatsappDialogClose();
          toast.warn(res.data.message, {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((err) => { });
  };

  return (
    <Dialog
      fullWidth
      keepMounted
      open={whatsappOpenDialog}
      TransitionComponent={Transition}
      onClose={whatsappDialogClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
        }
      }}
    >
      <DialogTitle
        sx={{
          fontSize: 18,
          fontWeight: 700,
          color: "#0b3363",
          boxShadow: "rgba(50, 50, 93, 0.1) 0px 4px 12px",
          mb: 1,
        }}
      >
        Initiate WhatsApp
      </DialogTitle>

      <DialogContent>
        <Stack spacing={3} mt={1}>
          <FormControl fullWidth size="small">
            <InputLabel id="branch-label">Branch</InputLabel>
            <Select
              labelId="branch-label"
              value={Branch}
              onChange={(e) => setBranch(e.target.value)}
              label="Branch"
            >
              <MenuItem value="">Select Branch</MenuItem>
              <MenuItem value="BMW">BMW</MenuItem>
              <MenuItem value="Rolls-Royce">Rolls-Royce</MenuItem>
              <MenuItem value="GeelyF">GeelyF</MenuItem>
            </Select>
          </FormControl>

          {Branch && (
            <FormControl>
              <FormLabel>Type</FormLabel>
              <RadioGroup
                row
                value={serviceType}
                onChange={(e) => {
                  setserviceType(e.target.value);
                  if (e.target.value === "Service") {
                    setserviceMessage(serviceText);
                    setserviceTypeValidation(true);
                  } else if (e.target.value === "Parts") {
                    setserviceMessage(partText);
                    setserviceTypeValidation(false);
                  } else {
                    setserviceMessage(salesText);
                    setserviceTypeValidation(false);
                  }
                }}
              >
                <FormControlLabel value="Sales" control={<Radio />} label="Sales" />
                <FormControlLabel value="Service" control={<Radio />} label="Service" />
                <FormControlLabel value="Parts" control={<Radio />} label="Parts" />
              </RadioGroup>
            </FormControl>
          )}

          {serviceType === "Service" && (
            <TextField
              fullWidth
              size="small"
              label="URL"
              type="url"
              value={url}
              onChange={(e) => seturl(e.target.value)}
            />
          )}

          <TextField
            label="Message"
            value={Branch === "" ? "" : serviceMessage}
            fullWidth
            multiline
            minRows={4}
            maxRows={6}
            disabled
            size="small"
          />
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={whatsappDialogClose}
          variant="outlined"
          color="error"
          size="small"
          sx={{ textTransform: "capitalize" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={ClickToWhatsapp}
          disabled={serviceTypeValidation}
          disableElevation
          size="small"
          sx={{ textTransform: "capitalize" }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WhatsAppInitDialogBox;
